import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { usePrimaryVault } from './usePrimaryVault';
import { usePersonalProfile } from '../entities/usePersonalProfile';

/** @category Instruments */
export function usePrimaryLockbox(profileId?: string) {
  const tokenizedApi = useTokenizedApi();

  const personalProfile = usePersonalProfile();
  profileId = profileId || personalProfile?.id;

  const primaryVault = usePrimaryVault(profileId);
  const lockboxesById = useQuery(tokenizedApi.treasury.lockboxesQuery())?.data
    ?.idMap;

  if (!lockboxesById || !primaryVault?.primaryLockboxId) {
    return;
  }

  return lockboxesById.get(primaryVault.primaryLockboxId);
}
